module.exports = __webpack_public_path__ + "img/ecu_banner_pt.49277564.jpg";